import { ATTRIBUTE } from '../../../../config/types';
import Input from './Input';
import { isBindable } from '../binding/selectBinding';
import runloop from '../../../../global/runloop';
import createItem from '../../createItem';
import Fragment from '../../../Fragment';

var Textarea = (function (Input) {
	function Textarea( options ) {
		var template = options.template;

		options.deferContent = true;

		Input.call( this, options );

		// check for single interpolator binding
		if ( !this.attributeByName.value ) {
			if ( template.f && isBindable( { template: template } ) ) {
				this.attributes.push( createItem( {
					owner: this,
					template: { t: ATTRIBUTE, f: template.f, n: 'value' },
					parentFragment: this.parentFragment
				} ) );
			} else {
				this.fragment = new Fragment({ owner: this, cssIds: null, template: template.f });
			}
		}
	}

	if ( Input ) Textarea.__proto__ = Input;
	Textarea.prototype = Object.create( Input && Input.prototype );
	Textarea.prototype.constructor = Textarea;

	Textarea.prototype.bubble = function bubble () {
		var this$1 = this;

		if ( !this.dirty ) {
			this.dirty = true;

			if ( this.rendered && !this.binding && this.fragment ) {
				runloop.scheduleTask( function () {
					this$1.dirty = false;
					this$1.node.value = this$1.fragment.toString();
				});
			}

			this.parentFragment.bubble(); // default behaviour
		}
	};

	return Textarea;
}(Input));

export default Textarea;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/view/items/element/specials/Textarea.js.map
